import React, { useState } from "react";
import "../styles/Footer.css";

const FooterSection = ({ title, children }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="footer-section">
      <div className="footer-title" onClick={() => setOpen(!open)}>
        {title}
        <span>{open ? "▲" : "▼"}</span>
      </div>
      {open && <ul>{children}</ul>}
      <hr />
    </div>
  );
};

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <FooterSection title="Nosotros">
          <li><a href="#">¿Quiénes somos?</a></li>
          <li><a href="#">Trabaja con nosotros</a></li>
          <li><a href="#">Sitios relacionados</a></li>
        </FooterSection>

        <FooterSection title="Información legal">
          <li><a href="#">Términos y condiciones</a></li>
          <li><a href="#">Política de privacidad</a></li>
        </FooterSection>

        <FooterSection title="Información de interés">
          <li><a href="#">Blog de salud</a></li>
          <li><a href="#">Preguntas frecuentes</a></li>
          <li><a href="#">Servicios y atenciones</a></li>
        </FooterSection>

        <FooterSection title="Dónde estamos">
          <li><a href="#">Nueva Providencia 1881</a></li>
          <li><a href="#">Fidel Oteiza 1971</a></li>
          <li><a href="#">Concepción Rengo 94</a></li>
        </FooterSection>

        <FooterSection title="Te ayudamos">
          <li><a href="#">Mesa Central: +56 2 2337 58578</a></li>
          <li><a href="#">Reserva de hora: +56 9 5606 5805</a></li>
          <li><a href="#">Concepción: +56 9 9920 8368</a></li>
        </FooterSection>
      </div>

      <div className="footer-socials">
        <a href="#"><i className="bi bi-instagram" /></a>
        <a href="#"><i className="bi bi-linkedin" /></a>
        <a href="#"><i className="bi bi-twitter-x" /></a>
        <a href="#"><i className="bi bi-facebook" /></a>
        <a href="#"><i className="bi bi-spotify" /></a>
        <a href="#"><i className="bi bi-youtube" /></a>
      </div>
  

      <p className="footer-copy">© 2025, Centro Médico Formed</p>
      <br></br>
      <br></br>

    </footer>
  );
};

export default Footer;
